export default __webpack_public_path__ + "images/MS.158162e.png";